import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=cdd85f52&"
import script from "./Permissions.vue?vue&type=script&lang=ts&"
export * from "./Permissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports